import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

const Video = ({ source }) => {
  const [src, setSrc] = useState(null)

  useEffect(() => {
    setSrc(source)
  }, [source])

  return (
    src && (
      <div className="video">
        <iframe src={src} frameBorder="0" allowFullScreen />
      </div>
    )
  )
}

Video.propTypes = {
  // make sure to use the Youtube embed URL 'https://www.youtube.com/embed/<video_eid>'
  source: PropTypes.string.required,
}

export default Video
